import { supabase } from './supabase';

/**
 * Tables whose SELECT policy filters `deleted_at IS NULL`. A plain
 * `update({ deleted_at })` on these fails RLS, so deletes go through the
 * `soft_delete` function instead. See supabase/migrations/0024_soft_delete_rpc.sql.
 */
export type SoftDeleteTable =
  | 'comments'
  | 'companies'
  | 'contacts'
  | 'custom_field_values'
  | 'custom_fields'
  | 'lead_sources'
  | 'leads'
  | 'project_invoices'
  | 'projects'
  | 'tag_assignments'
  | 'tags'
  | 'tasks';

export async function softDelete(table: SoftDeleteTable, ids: string | string[]): Promise<void> {
  const { error } = await supabase.rpc('soft_delete', {
    p_table: table,
    p_ids: Array.isArray(ids) ? ids : [ids],
  });
  if (error) throw error;
}
